import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFLookupCompany } from "../../../Shared/NewForms/NFLookupCompany";
import { NFLookupWarehouse } from "../../../Shared/NewForms/NFLookupWarehouse";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { NFLookupFixedAsset } from "../../../Shared/NewForms/NFLookupFixedAsset";
import { NFIntInput } from "../../../Shared/NewForms/NFIntInput";
import { NFLookupInput } from "../../../Shared/NewForms/NFLookupInput";
import { EnumHelper } from "../../../../helpers/EnumHelper";

export const FixedAssetsTakeInAccountsDetailMain = () => {
  const { watch } = useFormContext();
  const { t } = useTranslation();

  return (
    <>
      <Row>
        <Col sm={6}>
          <NFTextInput title={t("Document#")} fieldName={"documentNumber"} disabled />
        </Col>
        <Col sm={3}>
          <NFDateInput title={t("DocumentDate")} fieldName={"documentDate"} required={true} />
        </Col>
        <Col sm={3}>
          <NFDateInput title={t("TakeInAccountDate")} fieldName={"takeInAccountDate"} required={true} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupCompany fieldName={"companyId"} title={t("Company")} />
        </Col>
        <Col sm={6}>
          <NFLookupWarehouse fieldName={"warehouseId"} title={t("Warehouse")} companyId={watch("companyId")} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupFixedAsset fieldName={"fixedAssetId"} title={t("FixedAsset")} />
          <NFIntInput title={t("LifeDuration")} fieldName="lifeDuration" />
        </Col>
        <Col sm={6}>
          <NFLookupInput
            title={t("DepreciationMethod")}
            fieldName={"depreciationMethod"}
            items={EnumHelper.GetDepreciationMethodEnum()}
            // onValueChange={handleTypeChange}
          />
        </Col>
      </Row>
    </>
  );
};
